import FeedbackPage from './FeedbackPage'

const Feedback = () => {
  return <FeedbackPage />
}

export default Feedback
